export const REFERENCE_TYPE_NAME = {
  RE2020: "RE2020",
  EPCM: "E+C-",
};

export const ALLOTMENT_IDS = {
  NOOCO: 1,
  RE2020: 2,
  EPCM: 34,
};
